
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 200 200"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M164.347 36.653c5.467 5.468 5.467 14.332 0 19.8l-44.548 44.546 44.548 44.549c5.467 5.467 5.467 14.331 0 19.799-5.468 5.467-14.332 5.467-19.8 0L100 120.797l-44.548 44.55c-5.467 5.467-14.331 5.467-19.799 0-5.467-5.468-5.467-14.332 0-19.8L80.201 101 35.653 56.452c-5.467-5.467-5.467-14.331 0-19.799 5.468-5.467 14.332-5.467 19.8 0L100 81.2l44.548-44.547c5.467-5.467 14.331-5.467 19.799 0z","fill":"currentColor","fill-rule":"evenodd"}})])
          )
        }
      }
    